<top-bar [field]="field" [isLoadingField]="isLoadingField" [userProfile]="userProfile" [errorField]="errorGetField"></top-bar>
<ng-container *ngIf="errorGetField">
  <div class="container-fluid" style="min-height: 95vh;">
    <h5 class="text-center text-danger p-4">{{errorGetField}}. Please refresh the page or select another field.</h5>
  </div>
</ng-container>
<!--<ng-template #noError>
  <datasheet-calendar [userProfile]="userProfile" [isLoadingField]="isLoadingField"></datasheet-calendar>
</ng-template>-->
